// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LinkEmail: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#e00b5a",
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 12 9" width={width} height={height}>
            <path
                fill="currentColor"
                d="M1.5.75a.75.75 0 0 0-.75.75v.935l4.584 3.361c.396.29.936.29 1.332 0l4.584-3.36V1.5a.75.75 0 0 0-.75-.75zM.75 3.366V7.5c0 .415.335.75.75.75h9a.75.75 0 0 0 .75-.75V3.366L7.109 6.4a1.88 1.88 0 0 1-2.218 0zM0 1.5C0 .673.673 0 1.5 0h9c.827 0 1.5.673 1.5 1.5v6c0 .827-.673 1.5-1.5 1.5h-9C.673 9 0 8.327 0 7.5z"
            />
        </svg>
    );
};

export default React.memo(LinkEmail);
